<div
    *ngIf="editorLoaded$ | async as editorLoaded"
    tuiWrapper
    appearance="textfield"
    class="t-wrapper"
    [readOnly]="readOnly"
    [disabled]="disabled"
    [focus]="computedFocused"
    [hover]="pseudoHover"
    [invalid]="computedInvalid"
    (tuiActiveZoneChange)="onActiveZone($event)"
>
    <div class="t-toolbar-wrapper">
        <tui-toolbar
            *ngIf="editorLoaded"
            [tools]="tools"
            [disabled]="!interactive"
            (fileAttached)="fileAttached.emit($event)"
        >
            <ng-content select="tools"></ng-content>
        </tui-toolbar>
        <div
            class="t-placeholder"
            [class.t-placeholder_raised]="placeholderRaised"
        >
            <ng-content></ng-content>
        </div>
        <div
            *ngIf="hasExampleText"
            class="t-example-text"
        >
            {{ exampleText }}
        </div>
    </div>

    <tui-scrollbar
        *ngIf="editorLoaded"
        tuiEditorPortal
        class="t-scrollbar"
        (mousedown)="focus($event)"
    >
        <div
            tuiDropdownLimitWidth="auto"
            tuiDropdownSelectionPosition="tag"
            [tuiDropdownSelection]="dropdownSelectionHandler"
            [tuiDropdown]="dropdown"
        >
            <tui-editor-socket
                tuiTiptapEditor
                class="tui-editor-socket"
                [value]="value"
                [editable]="interactive"
                (valueChange)="onModelChange($event)"
                (stateChange)="(0)"
            ></tui-editor-socket>
        </div>

        <ng-template #dropdown>
            <tui-edit-link
                #link
                (addLink)="link.anchorMode ? addAnchor($event) : addLink($event)"
                (removeLink)="link.anchorMode ? removeAnchor() : removeLink()"
            ></tui-edit-link>
        </ng-template>

        <tui-editor-portal-host></tui-editor-portal-host>
    </tui-scrollbar>
</div>
